import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import BuyReportForm from "@components/dynamic/BuyReportForm";

const BuyByMonthReport = () => {
  useEffect(() => {
  }, []);


  return (
    <PageContainer
      title="Reporte de Compras por mes"
      backUrl="/user/dashboard-accounting"
    >
      <BuyReportForm />
    </PageContainer >
  );
}

export default BuyByMonthReport;
